import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export function usePrompt(when: boolean, message: string) {
    // const navigator = useContext(NavigationContext).navigator;

    useEffect(() => {
        if (!when) return;
        return;

        // const unblock = navigator.block((tx: any) => {
        //     if (window.confirm(message)) {
        //         unblock();
        //         tx.retry();
        //     }
        // });

        // return unblock;
    }, [navigator, when, message]);
}